import Vue from 'vue';
import Tabs from 'vue-tabs-component';
import Alpine from 'alpinejs'
import "flickity/dist/flickity.min.css"
import Flickity from 'flickity';

Vue.use(Tabs);

Vue.component('project-carousel', require('./components/ProjectCarousel.vue').default);
Vue.component('process-tabs', require('./components/ProcessTabs.vue').default);
Vue.component('process-tab', require('./components/ProcessTab.vue').default);
Vue.component('timeline', require('./components/Timeline.vue').default);
Vue.component('image-modal', require('./components/ImageModal.vue').default);
Vue.component('staff-member', require('./components/StaffMember.vue').default);
Vue.component('contact-form', require('./components/ContactForm.vue').default);

Vue.directive('image-modal', require('./directives/ImageModal.js').default);
Vue.directive('nav-toggle', require('./directives/NavToggle.js').default);

// Alpine Init
window.Alpine = Alpine

Alpine.start()

const app = new Vue({
    el: '#app',
});